import React from "react";
import {TableControls} from "./TableControls.js";


export const TableFooter = ({
    compact,
    view,
}) => {
    return <tfoot>
        <tr>
            <td colSpan={view.getActiveColumnDefs().length} className={"canold-table-footer-td" + (compact ? " canold-table-footer-td-compact" : "")}>
            </td>
        </tr>
    </tfoot>;
};

export default TableFooter;